import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3face5f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-new" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "carousel" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "0"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "development")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "1"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "marketing")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "2"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "UI/UX")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "3"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "project mng")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "4"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "development")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "5"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "marketing")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "6"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "UI/UX")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "carousel-item",
      "carousel-id": "7"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "item-text" }, "project mng")
      ])
    ])
  ])
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const data = reactive({
  carousel: null,
  carousel_items: null,
  items: null,
  currdeg: 0,
  active_carousel_id: 0
})

function getVW(value: number, breakpoint = 1920) {
  const context = breakpoint * 0.01
  return value / context
}
function countPosition(value: number, currentPosition: number) {
  if (currentPosition + value <= 0) {
    return (data.carousel_items.length + (currentPosition + value)) === data.carousel_items.length ? 0 : data.carousel_items.length + (currentPosition + value)
  } if (currentPosition + value >= data.carousel_items.length) {
    return data.carousel_items.length - (currentPosition + value) < 0 ? (data.carousel_items.length - (currentPosition + value)) * (-1) : data.carousel_items.length - (currentPosition + value)
  }
  return (currentPosition + value) === data.carousel_items.length ? 0 : currentPosition + value
}
function setStyleToNotActivePlates() {
  data.carousel_items[countPosition(-4, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0; transform: scale(0) translateZ(${getVW(400)}vw) translateY(${getVW(1000)}vw);`)
  data.carousel_items[countPosition(-3, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0.3; transform: scale(0.3) translateZ(${getVW(200)}vw) translateY(${getVW(600)}vw);`)
  data.carousel_items[countPosition(-2, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0.6; transform: scale(0.5) translateY(${getVW(40)}vw); -moz-transform: scale(0.5) translateY(${getVW(40)}vw`)
  data.carousel_items[countPosition(-1, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', 'opacity: 0.85; transform: scale(0.75) translateY(0);')
  data.carousel_items[countPosition(1, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', 'opacity: 0.85; transform: scale(0.75) translateY(0);')
  data.carousel_items[countPosition(2, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0.6; transform: scale(0.5) translateY(${getVW(-40)}vw);`)
  data.carousel_items[countPosition(3, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0.3; transform: scale(0.3) translateZ(${getVW(400)}vw) translateY(${getVW(-600)}vw) translateY(0);`)
  data.carousel_items[countPosition(4, data.active_carousel_id)].firstChild.firstChild.setAttribute('style', `opacity: 0; transform: scale(0) translateZ(${getVW(400)}vw) translateY(${getVW(-1000)}vw) translateY(0);`)
}
setTimeout(() => {
  // eslint-disable-next-line prefer-destructuring
  data.carousel = document.getElementsByClassName('carousel')
  data.carousel_items = document.getElementsByClassName('carousel-item')
  data.items = document.getElementsByClassName('item')
  for (let i = 0; i < data.carousel_items.length; i++) {
    data.carousel_items[i].style.cssText = `transform: rotateX(${(360 / data.carousel_items.length) * i}deg) translateZ(${getVW(300)}vw) rotateX(${(360 / data.carousel_items.length) * i * (-1)}deg)`
  }
  setStyleToNotActivePlates()
  data.carousel_items[0].firstChild.firstChild.style.cssText = 'opacity: 1'
  data.carousel_items[0].firstChild.firstChild.classList.add('active-carousel')
}, 10)

function rotate() {
  data.active_carousel_id++
  if (data.carousel_items.length === data.active_carousel_id) {
    data.active_carousel_id = 0
  }
  data.currdeg -= 360 / data.carousel_items.length
  if (document.getElementsByClassName('active-carousel').length > 0) {
    setTimeout(() => {
      document.getElementsByClassName('active-carousel')[0].classList.remove('active-carousel')
    }, 150)
  }
  data.carousel[0].style.cssText = `-webkit-transform: rotateX(${data.currdeg}deg); -moz-transform: rotateX(${data.currdeg}deg); -o-transform: rotateX(${data.currdeg}deg); transform: rotateX(${data.currdeg}deg)`
  for (let i = 0; i < data.items.length; i++) {
    data.items[i].style.cssText = `-webkit-transform: rotateX(${data.currdeg * (-1)}deg); -moz-transform: rotateX(${data.currdeg * (-1)}deg); -o-transform: rotateX(${data.currdeg * (-1)}deg);
    transform: rotateX(${data.currdeg * (-1)}deg)`
  }
  setTimeout(() => {
    setStyleToNotActivePlates()
    data.carousel_items[data.active_carousel_id].firstChild.firstChild.setAttribute('style', 'opacity: 1; transform: scale(none) translateY(0); -moz-transition-duration: 1ms;')
    data.carousel_items[data.active_carousel_id].firstChild.firstChild.classList.add('active-carousel')
  }, 300)
}

setTimeout(() => {
  setInterval(() => {
    rotate()
  }, 2000)
  // for (let i = 0; i < 5; i++) {
  //   setTimeout(() => {
  //     rotate()
  //   }, 2000 * i)
  // }
}, 10)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_2))
}
}

})